import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { EventDataContext } from "../EventDataContext";
import "../../styling/InvoiceTab.css";
import "../../styling/ClientPortal.css";

import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg";
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg";
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg";
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg";

const BusinessPackagesTab = () => {
  const { EventData } = useContext(EventDataContext);
  const [chosenPackage, setChosenPackage] = useState({});
  const [addons, setAddons] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedNewAddons, setSelectedNewAddons] = useState([]);
  const [allAddons, setAllAddons] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [showAddOptions, setShowAddOptions] = useState(false);
  const [showAddonSection, setShowAddonSection] = useState(false);
  const [showPackageSection, setShowPackageSection] = useState(false);

  let coverPic = otherPhoto;
  if (EventData.eventType == "corporate") {
    coverPic = businessPhoto;
  } else if (EventData.eventType == "birthday") {
    coverPic = birthdayPhoto;
  } else if (EventData.eventType == "wedding") coverPic = weddingPhoto;

  const fetchPackage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getPackageDetail/${EventData.packageId}`,
        { withCredentials: true }
      );
      setChosenPackage(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchNewPackage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getPackageDetail/${selectedPackageId}`,
        { withCredentials: true }
      );
      setChosenPackage(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAddons = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getAddonDetail/${EventData._id}`,
        { withCredentials: true }
      );
      setAddons(response.data.addons);
    } catch (error) {
      console.log(error);
    }
  };

  const [total, setTotal] = useState(0);

  const fetchAllAddons = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/get-addon?businessId=${EventData.businessId}`,
        { withCredentials: true }
      );
      setAllAddons(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllPackages = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/get-packages?businessId=${EventData.businessId}`,
        { withCredentials: true }
      );
      setAllPackages(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCheckboxChange = (id, isNew = false) => {
    if (isNew) {
      setSelectedNewAddons((prev) =>
        prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
      );
    } else {
      setSelectedAddons((prev) =>
        prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
      );
    }
  };

  const removeAddons = async () => {
    try {
      if (selectedAddons.length === 0) {
        alert("No addons selected for removal.");
        return;
      }
      await axios.put(
        `${process.env.REACT_APP_API_URL}/event/remove-addon`,
        {
          eventId: EventData._id,
          addonIds: selectedAddons,
        },
        { withCredentials: true }
      );

      fetchAddons();
      alert("Selected addons removed successfully.");
      setSelectedAddons([]);
    } catch (error) {
      console.log(error);
    }
  };

  const addAddons = async () => {
    try {
      if (selectedNewAddons.length === 0) {
        alert("No new addons selected to add.");
        return;
      }
      await axios.put(
        `${process.env.REACT_APP_API_URL}/event/add-addon`,
        {
          eventId: EventData._id,
          addonIds: selectedNewAddons,
        },
        { withCredentials: true }
      );
      fetchAddons();

      setSelectedNewAddons([]);
      setShowAddonSection(false);
    } catch (error) {
      console.log(error);
    }
  };

  const updatePackage = async () => {
    try {
      if (!selectedPackageId) {
        alert("No package selected.");
        return;
      }
      await axios.post(
        `${process.env.REACT_APP_API_URL}/event/update-package`,
        {
          eventId: EventData._id,
          packageId: selectedPackageId,
        },
        { withCredentials: true }
      );

      fetchNewPackage();

      setShowPackageSection(false);
      setSelectedPackageId(null);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPackage();
    fetchAddons();
  }, [EventData]);

  useEffect(() => {
    const updateAmount = async () => {
      try {
        const res = await axios.put(
          `${process.env.REACT_APP_API_URL}/event/update-amount`,
          {
            eventId: EventData._id,
          },
          { withCredentials: true }
        );

        setTotal(res.data.data.expPaymentAmount);
      } catch (error) {
        console.error("Failed to update amount:", error);
      }
    };

    updateAmount();
  }, [chosenPackage, addons]);

  return (
    <div style={{ width: "100%" }} className="packages-client-tab">
      <div style={{ position: 'relative', width: '100%', height: '224px', overflow: 'hidden', backgroundColor: '#000' }}>
        {/* 1. The Base Image */}
        <img
          src={coverPic}
          alt="cover"
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "cover",
            objectPosition: "top" 
          }}
        />

        {/* 2. The Blur Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          maskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
          WebkitMaskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
        }} />
        
        {/* 3. The Bottom Gradient & Text Overlay */}
        <div style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
          color: 'white',
          padding: '20px',
          boxSizing: 'border-box'
        }}>
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
            Your Package
          </h1>
          <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
            Date Booked: {new Date(EventData.eventDate).toLocaleDateString("en-US")}
          </p>
        </div>
      </div>

      <div>
        <div className="invoiceContent">
          <div
            className="right-panel-content"
            style={{ marginTop: "0px", padding: "20px" }}
          >
            <div className="right-panel-arrow-container">
              <h2
                style={{
                  marginTop: '0px',
                  marginBottom: "5px",
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                {chosenPackage?.name || "Package Name"}
              </h2>
              <h4 style={{ color: "#000", fontWeight: "bold", marginTop: '0px' }}>
                ${chosenPackage?.cost || "0.00"}
              </h4>
            </div>
            
            {/* EXACT MATCH TO BOOTHINFO.JS */}
            <div style={{ color: "#4D4D4D", fontSize: "0.95em" }}>
              {(chosenPackage?.description || "").split("\n").map((feature, i) => (
                <p key={i} style={{ margin: "3px 0" }}>{feature}</p>
              ))}
            </div>
          </div>

          <h2 style={{ marginTop: "30px", color: "#000000" }}>Add Ons</h2>

          {addons?.map((addon, index) => (
            <div
              className="bordered-box"
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "bold", color: "#000000" }}>
                  {addon.name}
                </div>
                {/* EXACT MATCH TO BOOTHINFO.JS */}
                <div style={{ color: "#555", marginTop: "7px", fontSize: "0.9em" }}>
                  {(addon?.description || "").split("\n").map((feature, i) => (
                    <p key={i} style={{ margin: "3px 0" }}>{feature}</p>
                  ))}
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "flex-start", paddingBottom: "84px" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#000000",
                    marginRight: "20px",
                    marginTop: "0px"
                  }}
                >
                  ${addon.cost}
                </div>
              </div>
            </div>
          ))}

          {/* Action Buttons */}
          {EventData.type === "manual" && (
            <div
              style={{
                display: "flex",
                gap: "15px",
                marginTop: "30px",
                position: "relative",
              }}
            >
              <button
                onClick={removeAddons}
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  padding: "10px",
                  background: "white",
                  border: "1px black solid",
                  color: "#080700",
                  boxShadow: "none",
                }}
              >
                Remove Items
              </button>

              {/* Hover Dropdown Button */}
              <div
                onMouseEnter={() => setShowAddOptions(true)}
                onMouseLeave={() => setShowAddOptions(false)}
                style={{ position: "relative" }}
              >
                <button
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    padding: "10px",
                    background: "white",
                    border: "1px black solid",
                    color: "#080700",
                    boxShadow: "none",
                  }}
                >
                  Add New Item
                </button>
                {showAddOptions && (
                  <div
                    style={{
                      position: "absolute",
                      top: "45px",
                      left: "0",
                      background: "white",
                      border: "1px solid #ccc",
                      zIndex: 10,
                    }}
                  >
                    <div
                      style={{ padding: "10px", cursor: "pointer" }}
                      onClick={() => {
                        fetchAllAddons();
                        setShowAddonSection(true);
                        setShowPackageSection(false);
                        setShowAddOptions(false);
                      }}
                    >
                      Addons
                    </div>
                    <div
                      style={{ padding: "10px", cursor: "pointer" }}
                      onClick={() => {
                        fetchAllPackages();
                        setShowPackageSection(true);
                        setShowAddonSection(false);
                        setShowAddOptions(false);
                      }}
                    >
                      Packages
                    </div>
                  </div>
                )}
              </div>

              {showAddonSection && selectedNewAddons.length > 0 && (
                <button
                  onClick={addAddons}
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    padding: "10px",
                    background: "white",
                    border: "1px black solid",
                    color: "#080700",
                    boxShadow: "none",
                  }}
                >
                  Add Selected Addons
                </button>
              )}

              {showPackageSection && selectedPackageId && (
                <button
                  onClick={updatePackage}
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    padding: "10px",
                    background: "white",
                    border: "1px black solid",
                    color: "#080700",
                    boxShadow: "none",
                  }}
                >
                  Change Package
                </button>
              )}
            </div>
          )}
          
          {/* Addon Selection UI */}
          {showAddonSection &&
            allAddons.map((addon, index) => (
              <div
                className="bordered-box"
                key={`new-${index}`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "bold", color: "#000000" }}>
                    {addon.name}
                  </div>
                  {/* EXACT MATCH TO BOOTHINFO.JS */}
                  <div style={{ color: "#555", marginTop: "7px", fontSize: "0.9em" }}>
                    {(addon?.description || "").split("\n").map((feature, i) => (
                      <p key={i} style={{ margin: "3px 0" }}>{feature}</p>
                    ))}
                  </div>
                </div>
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#000000",
                      marginRight: "20px",
                    }}
                  >
                    ${addon.cost}
                    <input
                      type="checkbox"
                      style={{ marginLeft: "5px" }}
                      checked={selectedNewAddons.includes(addon._id)}
                      onChange={() => handleCheckboxChange(addon._id, true)}
                    />
                  </p>
                </div>
              </div>
            ))}

          {/* Package Selection UI */}
          {showPackageSection &&
            allPackages.map((pkg, index) => (
              <div
                className="bordered-box"
                key={`new-${index}`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <div>
                  <h4 style={{ margin: 0, color: "black" }}>{pkg.name}</h4>
                  {/* EXACT MATCH TO BOOTHINFO.JS */}
                  <div style={{ margin: "5px 0", color: "#4D4D4D", fontSize: "0.95em" }}>
                    {(pkg?.description || "").split("\n").map((feature, i) => (
                      <p key={i} style={{ margin: "3px 0" }}>{feature}</p>
                    ))}
                  </div>
                </div>
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#000",
                      marginRight: "20px",
                    }}
                  >
                    ${pkg.cost}
                  </p>
                  <input
                    type="radio"
                    name="packageSelect"
                    onChange={() => setSelectedPackageId(pkg._id)}
                    checked={selectedPackageId === pkg._id}
                  />
                </div>
              </div>
            ))}

          {/* Totals */}
          <div
            style={{
              borderTop: "1px solid #D9D9D9",
              marginTop: "30px",
              paddingTop: "20px",
              display: "flex",
              justifyContent: "right",
              color: "#625C73",
            }}
          >
            <div>Subtotal</div>
            <div style={{ width: "20%" }}></div>
            <div>${total}</div>
          </div>
          <div
            style={{
              borderBottom: "1px solid #D9D9D9",
              paddingBottom: "10px",
              display: "flex",
              justifyContent: "right",
              color: "#625C73",
            }}
          >
            <div>Total</div>
            <div style={{ width: "20%" }}></div>
            <div>${total}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessPackagesTab;